module.exports = __webpack_public_path__ + "images/vibecode_logo_loyalty.svg";


//////////////////
// WEBPACK FOOTER
// ./images/vibecode_logo_loyalty.svg
// module id = 15
// module chunks = 1